import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const LibraryIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 20.15 20.15" {...props}>
    <path d="M17.78,1.68V0H0V17.48H1.63v2.67H20.15V1.68ZM5.51,7.55,8.24,9.49V1.08h8.35V16.4H1.19V1.08H2.77V9.49ZM3.94,1.08H7.07V7.23L5.51,6.12,3.94,7.24Zm-1.12,18V17.48h15V2.77H19v16.3Z" />
  </SvgIcon>
));

export default React.memo(LibraryIcon);
